import PropTypes from "prop-types";
import { Component } from "react";

class Toolbar extends Component {
    constructor() {
        super();
        this.state = { isToggled: false };
    }
    
    UNSAFE_componentWillReceiveProps() {
        if(this.props.displayFilters) {
            if(!this.state.isToggled && !this.props.isSearchResultGrid) { 
                this.setState({ isToggled: true });
                this.props.onToggleFilter();
            }
        }
    }
    render() {
        return (null);
    }
}

Toolbar.propTypes = {
    onToggleFilter: PropTypes.func,
    isSearchResultGrid: PropTypes.string,
    displayFilters: PropTypes.bool,
};

export default Toolbar;